<!--
//================================================================================
// ID:BC009C1
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC009C1
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/09/06 | 富士通株式会社         | 新規作成
// 01.01.00 | 2022/10/03 | 富士通Japan株式会社    | 令和4年度改修対応（2次リリース）
// 01.02.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
// 01.03.00 | 2023/04/26 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.04.00 | 2023/09/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
// 01.05.00 | 2024/09/17 | 富士通Japan株式会社    | 令和6年度改修対応（1次リリース）
// 01.06.00 | 2025/02/03 | 富士通Japan株式会社    | 令和6年度改修対応（2次リリース）
//================================================================================
-->
<template>
	<main class="contents__main">
		<div v-show="disp.stepFlg">
			<step-bar
				:bosyuHoshiki="formC1.bosyuHoshiki"
				:transKbn="formC1.transKbn"
			/>
		</div>
		<div v-if="co_isIE()" class="contents__main--mosikomi" />
		<error-message />
		<!--◆編集エリア START◆-->
		<div class="contents__input-main">
			<div class="contents__title">
				<label class="contents__title--label"></label>
			</div>
			<br/>
			<div>
				<label>申込み内容を確認してください。（まだ、申込みは完了していません）</label>
			</div>
			<br/>
			<h2 class="contents__h2 contents__jyutaku">申込む住宅</h2>
			<div class="contents__div--PC">
				<section class="margin__bottom-m10">
					<table border="1" class="list border__collapse">
						<thead>
							<tr id="listheader">
								<th id="listtitle01">
									<a :href="disp.nyukyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">入居人数</a>
								</th>
								<th v-if="disp.listHideKbn == 1" id="listtitle02">申込地区番号<br>
									<a v-if="!disp.zuiziFlg && !disp.pointFlg" :href="disp.yuguLink" target="_blank" rel="noopener noreferrer" tabindex="-1">優遇抽せんの有無</a>
								</th>
								<th v-else id="listtitle12">申込地区番号<br>
									<a v-if="!disp.zuiziFlg && !disp.pointFlg" :href="disp.yuguLink" target="_blank" rel="noopener noreferrer" tabindex="-1">優遇抽せんの有無</a>
								</th>
								<th v-if="disp.listHideKbn == 1" id="listtitle03">
									<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
									<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
									<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
								</th>
								<th v-else-if="disp.isAkijyuko" id="listtitle33">
									<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
									<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
									<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
								</th>
								<th v-else-if="disp.listHideKbn == 2" id="listtitle13">
									<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
									<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
									<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a></th>
								<th v-else id="listtitle23">
									<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
									<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
									<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
								</th>
								<th v-if="!disp.zuiziFlg" id="listtitle04">募集<br />戸数</th>
								<th v-if="disp.isAkijyuko" id="listtitle30">空き<br />住戸数</th>
								<th id="listtitle05">間取り<br>専用面積<br />(m&sup2;)</th>
								<th v-if="disp.listHideKbn == 1" id="listtitle06">
									<a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a><br>
									<a :href="disp.elevatorLink" target="_blank" rel="noopener noreferrer" tabindex="-1">エレベーター</a><br>
									<a :href="disp.taisyokaiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">対象階</a>
								</th>
								<th v-else id="listtitle06">
									<a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a><br>
									<a :href="disp.elevatorLink" target="_blank" rel="noopener noreferrer" tabindex="-1">エレベーター</a></th>
								<th id="listtitle07">
									<a :href="disp.shiyoryoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">使用料(円)</a>
								</th>
								<th v-if="disp.listHideKbn == 1" id="listtitle08">
									<a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a>
								</th>
								<th v-else-if="disp.isAkijyuko" id="listtitle28">
									<a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a>
								</th>
								<th v-else id="listtitle18">
									<a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a>
								</th>
								<th v-if="disp.listHideKbn == 1" id="listtitle09">
									<a :href="disp.jikoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">事故内容</a>
								</th>
								<th v-else-if="disp.listHideKbn == 2" id="listtitle19">
									<a :href="disp.bairituLink" target="_blank" rel="noopener noreferrer" tabindex="-1">参考<br />倍率</a>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr class="list-Countents">
								<td id="listtd">{{ disp.nyukyoSu }}</td>
								<td id="listtd" v-if="!disp.zuiziFlg && !disp.pointFlg">{{ disp.noMouchiku }}<br />{{ disp.kbYugu }}</td>
								<td id="listtd" v-else>{{ disp.noMouchiku }}</td>
								<td id="listjyusho">
									<label id="listtdleft">{{ disp.jyutakuName }}</label><br />
									<label id="listtdleft">{{ disp.kusicyo }}</label><br />
									<label id="listtdleft">{{ disp.trans }}</label>
								</td>
								<td id="listtd" v-if="!disp.zuiziFlg">
									{{ disp.nuBosyukosu }}
								</td>
								<td id="listtd" v-if="disp.isAkijyuko">
									<span v-if="disp.nuAkijyukosu != null && disp.nuAkijyukosu != ''">{{ disp.nuAkijyukosu }}</span>
									<span v-else>{{ disp.zenkakuHyphen }}</span>
								</td>
								<td id="listtd" class="contents__kaigyo--css">{{ disp.madori }}<br />{{ disp.senyoArea }}</td>
								<td id="listtd" v-if="disp.listHideKbn == 1">
									{{ disp.ymkensetu }}<br />{{ disp.elevatorUmu }}<br />{{ disp.jikotaisyo }}
								</td>
								<td id="listtd" v-else>
									{{ disp.ymkensetu }}<br />{{ disp.elevatorUmu }}
								</td>
								<td id="listtd">{{ disp.moSiyoryo }}</td>
								<td id="listtdleft">{{ disp.siyouEtc }}</td>
								<td id="listtdleft" v-if="disp.listHideKbn == 1">
									{{ disp.jikonaiyo }}
								</td>
								<td id="listtd" v-else-if="disp.listHideKbn == 2">
									<span v-if="disp.nuBairitu != null && disp.nuBairitu != ''">{{ disp.nuBairitu }}</span>
									<span v-else>{{ disp.zenkakuHyphen }}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</section>
			</div>
			<div class="contents__div--MOBILE">
				<section>
					<table class="contents__table--stripe list contents__list-mobile1">
						<tbody>
							<tr>
								<td class="border__top-none margin__bottom-5 contents__kaigyo--css">
									<label>
										<a :href="disp.nyukyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">入居人数</a>
									</label>:{{ disp.nyukyoSu }}<br/>
									<span v-if="!disp.zuiziFlg">
										<label>募集戸数</label>:{{ disp.nuBosyukosu }}<br/>
									</span>
									<span v-if="disp.isAkijyuko">
										<label>空き住戸数</label>
										<span v-if="disp.nuAkijyukosu != null && disp.nuAkijyukosu != ''">:{{ disp.nuAkijyukosu }}</span>
										<span v-else>:{{ disp.zenkakuHyphen }}</span><br/>
									</span>
									<label>申込地区番号</label>:{{ disp.noMouchiku }}<br/>
									<span v-if="!disp.zuiziFlg && !disp.pointFlg">
										<label>
											<a :href="disp.yuguLink" target="_blank" rel="noopener noreferrer" tabindex="-1">優遇抽せんの有無</a>
										</label>:{{ disp.kbYugu }}<br/>
									</span>
									<label>
										<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a>
									</label>:{{ disp.jyutakuName }}<br/>
									<label>
										<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a>
									</label>:{{ disp.kusicyo }}<br/>
									<label>
										<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
									</label>:{{ disp.trans }}<br/>
									<label>間取り</label>:{{ disp.madori }}<br/>
									<label>専用面積(m&sup2;)</label>:{{ disp.senyoArea }}<br/>
									<label>
										<a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a>
									</label>:{{ disp.ymkensetu }}<br/>
									<label>
										<a :href="disp.elevatorLink" target="_blank" rel="noopener noreferrer" tabindex="-1">エレベーター</a>
									</label>:{{ disp.elevatorUmu }}<br/>
									<span v-if="disp.listHideKbn == 1">
										<label>
											<a :href="disp.taisyokaiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">対象階</a>
										</label>:{{ disp.jikotaisyo }}<br/>
									</span>
									<label>
										<a :href="disp.shiyoryoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">使用料(円)</a>
									</label>:{{ disp.moSiyoryo }}<br/>
									<label>
										<a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a>
									</label>:{{ disp.siyouEtc }}<br/>
									<span v-if="disp.listHideKbn == 2">
										<label>
											<a :href="disp.bairituLink" target="_blank" rel="noopener noreferrer" tabindex="-1">参考倍率</a>
										</label>
										<span v-if="disp.nuBairitu != null && disp.nuBairitu != ''">:{{ disp.nuBairitu }}</span>
										<span v-else>:{{ disp.zenkakuHyphen }}</span>
									</span>
									<span v-else-if="disp.listHideKbn == 1">
										<label>
											<a :href="disp.jikoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">事故内容</a>
										</label>:{{ disp.jikonaiyo }}<br />
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</section>	
			</div>
			<section>
				<h2 class="contents__h2 contents__mosikomi1">申込情報</h2>
				<table class="contents__table--stripe detail_split" >
					<tbody>
						<tr class="contents__input--tr">
							<th class="contents__input--title padding__bottom-zero">募集の種類</th>
							<td class="width-bosyu">
								{{ disp.nmBosyu }}
							</td>
							<th class="contents__input--title jyutaku-title">住宅の種別</th>
							<td class="width-jyutaku padding-jyutaku">
								<div>
									<p class="p__multiple-row">
										{{ disp.nmZyutaku }}
									</p>
								</div>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title padding__bottom-zero">現在、申込者を含め同居している人数</th>
							<td colspan="3" class="padding__top">
								{{ formC1.nuDoukyo }}人
								<div class="contents__caution--div contents__nyukyotyui1">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											申込者本人を含めた人数
										</p>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title padding__bottom-zero">都営住宅に入居する人数</th>
							<td colspan="3" class="padding__top">
								<div>
									{{ formC1.nuNyukyo }}人
								</div>
								<div class="contents__caution--div contents__nyukyotyui1">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											申込者本人を含めた人数
										</p>
									</div>
								</div>
								<caution-message
									:classDiv="'contents__caution--div contents__nyukyotyui2'"
									:tyuibunItems="disp.nyukyoItems"
								/>
							</td>
						</tr>
						<tr v-if="formC1.bosyuHoshiki != BOSYU_HOSHIKI.ZUIJI" class="contents__input--tr">
							<th class="contents__input--title padding__bottom-zero">被災者世帯での申込み</th>
							<td colspan="3" class="padding__top">
								<check-box
									:classDiv="'width-hisaisya'"
									:modelValue="formC1.fgHisaisetai"
									:name="'被災者世帯'"
									:groupId="'fgHisaisetai'"
									:listItems="disp.hisaisyaList"
									:disabledFlg="true"
									@update:modelValue="formC1.fgHisaisetai = $event"
									ref="fgHisaisetai"
								/>
								<caution-message
									:classDiv="'font-size'"
									:tyuibunItems="disp.hisaisyaItems"
								/>
								<div id="contents--name__area" class="padding__top contents-hisaiNaiyo">
									<div>
										<label class="hisaiNaiyo-title">被災の内容</label>
									</div>
									<div>
										{{ disp.nmHisainaiyou }}
									</div>
								</div>
								<caution-message
									:classDiv="'contents__hisaisyatyui'"
									:tyuibunItems="disp.hisaiNaiyoItems"
								/>
							</td>
						</tr>
						<tr class="contents__input--tr">
							<th class="contents__input--title padding__bottom-zero">申込区分</th>
							<td  colspan="3" class="padding__top">
								{{ formC1.nmMosikomi }}
								<caution-message
									:classDiv="'width-moukbn1'"
									:cdHanyo1="'T0010'"
									:cdHanyo2="formC1.mouItems1cdHanyo2"
								/>
								<caution-message
									:classDiv="'width-moukbn2'"
									:tyuibunItems="disp.mouItems2"
									:linkUrlItems="formC1.mosikomiLinkItems"
								/>
								<caution-message
									v-if="formC1.zyutakuInfo['kbYuguFg'] == '1'"
									:classDiv="'width-moukbn3'"
									:tyuibunItems="disp.mouItems3"
								/>
							</td>
						</tr>
					</tbody>
				</table>
				<br/>
				<h2 class="contents__h2 contents__mosikomi2">申込者情報（この方が都営住宅使用許可後の名義人となります。）</h2>
				<table class="contents__table--stripe detail" >
					<tbody>
						<tr>
							<th  class="contents__input--title border__bottom-none padding__bottom-zero">
								申込者
							</th>
							<td class="border__bottom-none padding__top">
								<div id="contents--name__area">
									<div>
										氏：{{ formC1.nmMouname1 }}
									</div>
									<div>
										名：{{ formC1.nmMouname2 }}
									</div>
								</div>
							</td>
						</tr>
						<tr class="background__color--white">
							<th  class="contents__input--title mouKana-title">
								フリガナ
							</th>
							<td class="padding__top">
								<div id="contents--name__area">
									<div>
										氏：{{ formC1.nmMoukana1 }}
									</div>
									<div>
										名：{{ formC1.nmMoukana2 }}
									</div>
								</div>
							</td>
						</tr>
						<tr class="background__color--light-gray">
							<th  class="contents__input--title border__bottom-none padding__bottom-zero">
								日本での通称名
							</th>
							<td class="border__bottom-none padding__top">
								<div class="contents__tusyoTyui line-height">
									<font-awesome-icon icon="exclamation-triangle" />
									<label class="margin__tusyoTyui">申込者が外国人で、日本式の名前を住民票に登録している場合のみ</label>
								</div>
								<div id="contents--name__area">
									<div v-if="formC1.nmMoutusyoname1 != ''">
										氏：{{ formC1.nmMoutusyoname1 }}
									</div>
									<div v-if="formC1.nmMoutusyoname2 != ''">
										名：{{ formC1.nmMoutusyoname2 }}
									</div>
									<div v-else class="margin__bottom-10">
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title contents__tusyoKana">
								通称名のフリガナ
							</th>
							<td class="padding__top">
								<div id="contents--name__area">
									<div v-if="formC1.nmMoutusyokana1 != ''">
										氏：{{ formC1.nmMoutusyokana1 }}
									</div>
									<div v-if="formC1.nmMoutusyokana2 != ''">
										名：{{ formC1.nmMoutusyokana2 }}
									</div>
									<div v-else class="margin__bottom-20">
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title padding__bottom-zero">生年月日</th>
							<td class="padding__top">
								{{ co_editDate(formC1.dtMoubirthday) }}&nbsp;(満{{ co_calcAge(formC1.dtMoubirthday) }}歳)
								<div v-if="formC1.bosyuHoshiki == BOSYU_HOSHIKI.ZUIJI">
									<caution-message
										:classDiv="'birthday-tyui'"
										:tyuibunItems="disp.ageItems3"
									/>
								</div>
								<div v-else>
										<caution-message
										:classDiv="'birthday-tyui'"
										:tyuibunItems="disp.ageItems1"
									/>
								</div>
								<caution-message
									:tyuibunItems="disp.ageItems2"
								/>
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title padding__bottom-zero">郵便番号</th>
							<td class="padding__top">
								{{ formC1.noMouzip1 }}
								-
								{{ formC1.noMouzip2 }}
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title padding__bottom-zero">現住所<br/>
							</th>
							<td class="padding__top">
								{{ formC1.txMouadr1 }}
								<div class="contents-txMouadr">
									{{ formC1.txMouadr2 }}
								</div>
								<div class="contents-txMouadr contents-txMouadr-last">
									{{ formC1.txMouadr3 }}
								</div>
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title padding__bottom-zero">電話番号</th>
							<td class="padding__top">
								{{ formC1.idMoutel1 }}
								-
								{{ formC1.idMoutel2 }}
								-
								{{ formC1.idMoutel3 }}
								<div class="contents__caution--div div_row tel-tyui">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											平日の日中に連絡のつく電話番号
										</p>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title padding__bottom-zero">都内居住年数</th>
							<td class="padding__top">
								{{ formC1.nuKyojyu }}年
								<div class="contents__caution--div div_row kyojyu-tyui">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											現住所を含めた都内に継続して居住している年数
										</p>
									</div>
								</div>
								<div class="contents__caution--div div_row">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											居住年数が1年未満の場合は1年
										</p>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title zairyu-title">在留資格</th>
							<td class="zairyuSikaku-title padding-zairyu">
								<div class="contents__zairyuTyui line-height">
									<font-awesome-icon icon="exclamation-triangle" />
									<label class="margin__tusyoTyui">申込者が外国人の場合のみ</label>
								</div>
								<div class="contents__caution--div zairyu-tyui">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple" style="color:red;">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple" style="color:red;">
											外国人の申込者については、中長期在留者で、申込日から審査日まで継続して在留資格を有しており、そのことが住民票の写しで証明できることが必要です。
										</p>
									</div>
								</div>
								<p class="p__multiple-row">
									{{ disp.nmZairyusikaku }}
								</p>
								<caution-message
									v-if="!co_isEmpty(disp.zairyuItems)"
									:classDiv="'margin__top-15'"
									:tyuibunItems="disp.zairyuItems"
								/>
							</td>
						</tr>
						<tr class="background__color--light-gray">
							<th class="contents__input--title padding__bottom-zero">在留期間</th>
							<td class="padding__top">
								<div v-if="formC1.dtZairyuStt != ''">
									{{ co_editDate(formC1.dtZairyuStt) }}～{{ co_editDate(formC1.dtZairyuEnd) }}
								</div>
								<div v-else class="height-notentered">
								</div>
							</td>
						</tr>
						<tr class="contents__input--tr background__color--white">
							<th class="contents__input--title padding__bottom-zero">
								年間所得金額
							</th>
							<td class="padding__top">
								<div class="height-moSyotoku">
									{{ co_commaSeparated(formC1.moSyotoku) }}円
								</div>
								<caution-message
									:classDiv="'moSyotoku-tyui'"
									:tyuibunItems="disp.moSyotokuItems"
								/>
							</td>
						</tr>
						<tr class="contents__input--tr background__color--light-gray">
							<th class="contents__input--title padding__bottom-zero">特別控除</th>
							<td class="padding__kojto">
								<div class="height-kojto">
									<p class="p__multiple-row">
										{{ disp.nmKojto }}
									</p>
								</div>
								<caution-message
									:tyuibunItems="disp.kojtoItems"
								/>
							</td>
						</tr>
					</tbody>
				</table>
				<div v-if="formC1.bosyuHoshiki == BOSYU_HOSHIKI.TEIKI_POINT">
					<br/>
					<div class="div-toggle-select-margin">
						<h2 class="contents__h2">身体障害者手帳の交付を受けていますか</h2>
						<div class="width-bekkyoUmu contents__toggle-nyukyo">
							{{ disp.nmTecyo1 }}
						</div>
						<section v-if="formC1.kbTecyo1 == '1'">
							<table class="contents__table--stripe detail">
								<tbody>
									<tr class="contents__input--tr background__color--light-white">
										<th class="contents__input--title">
											等級等
										</th>
										<td class="padding__top">
											{{ disp.nmTokyu1 }}
										</td>
									</tr>
									<tr class="contents__input--tr background__color--light-gray">
										<th class="contents__input--title">
											交付または更新年月日
										</th>
										<td class="padding__top">
											{{ co_editDate(formC1.dtKoufuKousin1) }}
										</td>
									</tr>
								</tbody>
							</table>
						</section>
					</div>
					<div class="div-toggle-select-margin">
						<h2 class="contents__h2">愛の手帳の交付を受けていますか</h2>
						<div class="width-bekkyoUmu contents__toggle-nyukyo">
							{{ disp.nmTecyo2 }}
						</div>
						<section v-if="formC1.kbTecyo2 == '1'">
							<table class="contents__table--stripe detail">
								<tbody>
									<tr class="contents__input--tr background__color--light-white">
										<th class="contents__input--title">
											等級等
										</th>
										<td class="padding__top">
											{{ disp.nmTokyu2 }}
										</td>
									</tr>
									<tr class="contents__input--tr background__color--light-gray">
										<th class="contents__input--title">
											交付または更新年月日
										</th>
										<td class="padding__top">
											{{ co_editDate(formC1.dtKoufuKousin2) }}
										</td>
									</tr>
								</tbody>
							</table>
						</section>
					</div>
					<div class="div-toggle-select-margin">
						<h2 class="contents__h2">精神障害者保健福祉手帳の交付を受けていますか</h2>
						<div class="width-bekkyoUmu contents__toggle-nyukyo">
							{{ disp.nmTecyo3 }}
						</div>
						<section v-if="formC1.kbTecyo3 == '1'">
							<table class="contents__table--stripe detail">
								<tbody>
									<tr class="contents__input--tr background__color--light-white">
										<th class="contents__input--title">
											等級等
										</th>
										<td class="padding__top">
											{{ disp.nmTokyu3 }}
										</td>
									</tr>
									<tr class="contents__input--tr background__color--light-gray">
										<th class="contents__input--title">
											交付または更新年月日
										</th>
										<td class="padding__top">
											{{ co_editDate(formC1.dtKoufuKousin3Stt) }}
										</td>
									</tr>
									<tr class="contents__input--tr background__color--light-white">
										<th class="contents__input--title">
											期限
										</th>
										<td class="padding__top">
											{{ co_editDate(formC1.dtKoufuKousin3End) }}
										</td>
									</tr>
								</tbody>
							</table>
						</section>
					</div>
					<div class="div-toggle-select-margin">
						<h2 class="contents__h2">障害年金の受給に関し、障害の程度が精神障害１級～３級と同程度であると判定されていますか</h2>
						<div class="width-bekkyoUmu contents__toggle-nyukyo">
							{{ disp.nmTecyo4 }}
						</div>
						<section v-if="formC1.kbTecyo4 == '1'">
							<table class="contents__table--stripe detail">
								<tbody>
									<tr class="contents__input--tr background__color--light-white">
										<th class="contents__input--title">
											年金証書の障害等級
										</th>
										<td class="padding__top">
											{{ disp.nmSyogaiTokyu }}
										</td>
									</tr>
									<tr class="contents__input--tr background__color--light-gray">
										<th class="contents__input--title">
											診断書の種類
										</th>
										<td class="padding__top">
											{{ disp.nmSindanSyurui }}
										</td>
									</tr>
								</tbody>
							</table>
						</section>
					</div>
				</div>
				<br/>
				<h2 class="contents__h2">申込日時点の勤務先又は学校の名称・所在地</h2>
				<section>
					<table class="contents__table--stripe detail">
						<tbody>
							<tr class="contents__input--tr background__color--white">
								<th class="contents__input--title padding__bottom-zero">所在地</th>
								<td class="padding__kinmusaki">
									<div class="margin-top-15">
										{{ formC1.txSyozaichi }}
									</div>
								</td>
							</tr>
							<tr class="contents__input--tr background__color--light-gray">
								<th class="contents__input--title padding__bottom-zero">名称</th>
								<td class="padding__kinmusaki">
									<div class="margin-top-15">
										{{ formC1.txName }}
									</div>
								</td>
							</tr>
							<tr class="contents__input--tr background__color--white">
								<th class="contents__input--title padding__bottom-zero">電話番号</th>
								<td class="padding__kinmusaki">
									<div v-if="formC1.idTel1 != null && formC1.idTel1 != ''" class="margin-top-15">
										{{ formC1.idTel1 }}
										-
										{{ formC1.idTel2 }}
										-
										{{ formC1.idTel3 }}
									</div>
								</td>
							</tr>
							<tr class="contents__input--tr background__color--light-gray">
								<th class="contents__input--title padding__bottom-zero">勤務（開業）開始日</th>
								<td class="padding__kinmusaki">
									<div class="margin-top-15">
										{{ co_editDate(formC1.dtYmdStt) }}
									</div>
								</td>
							</tr>
							<tr class="contents__input--tr background__color--white">
								<th class="contents__input--title padding__bottom-zero">職業</th>
								<td class="padding__kinmusaki">
									<div class="margin-top-15">
										{{ disp.nmSyokugyo }}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</section>
				<div v-if="!disp.aloneFlg">
					<div class="toei-jyutaku">
						<br/>
						<h2 class="contents__h2 contents__mosikomi3">都営住宅に同居予定の方</h2>
					</div>
					<div class="contents__div--PC">
						<table  class="list2 border__collapse clear-both">
							<thead>
								<tr id="listheader" class="contents__list font-size">
									<th class="contents__thtd--btn"></th>
									<th class="contents__table--nyukyo">No</th>
									<th class="contents__table--nyukyo">氏名</th>
									<th class="contents__table--nyukyo">続柄</th>
									<th class="contents__table--nyukyo">年齢</th>
									<th class="contents__table--nyukyo">年間所得金額</th>
									<th class="contents__table--nyukyo">特別控除</th>
									<th v-if="formC1.bosyuHoshiki == BOSYU_HOSHIKI.TEIKI_POINT" class="contents__table--nyukyo">
										手帳の種類
									</th>
								</tr>
							</thead>
							<tbody>
								<tr id="listcountents" v-for="row in formC1.nyukyoList" :key="row.noNyukyo" class="font-size">
									<td class="contents__thtd--btn">
										<input
											type="button"
											:value="'同居者表示'"
											class="contents__btn--normal table-button"
											:tabindex="row.noNyukyo"
											@click="openConfirmNyukyosya(row.noNyukyo)"
											ref="nyukyoBtn">
									</td>
									<td class="contents__table--nyukyo">{{ row.noNyukyo }}</td>
									<td class="text-align-left contents__table--nyukyo">
										&nbsp;{{ row.nmName1 }}&nbsp;&nbsp;{{ row.nmName2 }}
									</td>
									<td class="contents__table--nyukyo">
										{{ row.nmTudukigara }}
									</td>
									<td class="contents__table--nyukyo">
										満{{ co_calcAge(row.dtBirthday) }}歳
									</td>
									<td class="text-align-right contents__table--nyukyo">
										{{ co_commaSeparated(row.moSyotoku) }}円&nbsp;
									</td>
									<td class="text-align-left contents__table--nyukyo">
										&nbsp;{{ row.nmKojto }}
									</td>
									<td  v-if="formC1.bosyuHoshiki == BOSYU_HOSHIKI.TEIKI_POINT" class="text-align-left contents__table--nyukyo">
										&nbsp;{{ row.nmTecyoKind }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="contents__div--MOBILE">
						<table class="contents__table--stripe detail list width-list">
							<tbody>
								<tr v-for="row in formC1.nyukyoList" :key="row.noNyukyo">
									<td class="padding__top--nyukyolist">
										<label>
											<input
												type="button"
												:value="'同居者表示'"
												class="contents__btn--normal table-button"
												:tabindex="row.noNyukyo"
												@click="openConfirmNyukyosya(row.noNyukyo)"
												ref="nyukyoBtnMobile">
										</label>
										<br/>
										<label>No</label>:
											{{ row.noNyukyo }}
										<br/>
										<label>氏名</label>:
											&nbsp;{{ row.nmName1 }}&nbsp;&nbsp;{{ row.nmName2 }}
										<br/>
										<label>続柄</label>:
											{{ row.nmTudukigara }}
										<br />
										<label>年齢</label>:
											満{{ co_calcAge(row.dtBirthday) }}歳
										<br/>
										<label>年間所得金額</label>:
											{{ co_commaSeparated(row.moSyotoku) }}円&nbsp;
										<br/>
										<label>特別控除</label>:
											&nbsp;{{ row.nmKojto }}
										<div v-if="formC1.bosyuHoshiki == BOSYU_HOSHIKI.TEIKI_POINT">
											<label>手帳の種類</label>:
												&nbsp;{{ row.nmTecyoKind }}
										</div>
									</td>
								</tr>
							</tbody>
							<div ref="nyukyoMobileB"></div>
						</table>
					</div>
				</div>
				<div v-else class="margin_dokyoList"></div>
				<div class="toei-jyutaku">
					<h2 class="contents__h2 contents__huyoName">遠隔地扶養者（申込者又は同居親族の所得税法上の扶養親族で、都営住宅に入居しない方）</h2>
				</div>
				<div class="contents__div--PC">
					<table  class="list3 border__collapse clear-both">
						<thead>
							<tr id="listheader" class="contents__list font-size">
								<th class="contents__thtd--btn"></th>
								<th class="contents__table--nyukyo">No</th>
								<th class="contents__table--nyukyo">氏名</th>
								<th class="contents__table--nyukyo">申込者との関係</th>
								<th class="contents__table--nyukyo">年齢</th>
								<th class="contents__table--nyukyo">特別控除</th>
							</tr>
						</thead>
						<tbody>
							<tr id="listcountents" v-for="row in formC1.fuyoList" :key="row.noFuyo" class="font-size">
								<td class="contents__thtd--btn">
									<input
										type="button"
										:value="'遠隔地扶養者表示'"
										class="contents__btn--normal table-button"
										:tabindex="row.noFuyo + formC1.nyukyoList.length"
										@click="openConfirmEnkakuchiFuyosya(row.noFuyo)"
										ref="fuyoBtn">
								</td>
								<td class="contents__table--nyukyo">{{ row.noFuyo }}</td>
								<td class="text-align-left contents__table--nyukyo">
									&nbsp;{{ row.nmFuyoName1 }}&nbsp;&nbsp;{{ row.nmFuyoName2 }}
								</td>
								<td class="contents__table--nyukyo">
									{{ row.nmMoukankei }}
								</td>
								<td class="contents__table--nyukyo">
									満{{ co_calcAge(row.dtBirthday) }}歳
								</td>
								<td class="text-align-left contents__table--nyukyo">
									&nbsp;{{ row.nmKojto }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="contents__div--MOBILE">
					<table class="contents__table--stripe detail list width-list">
						<tbody>
							<tr v-for="row in formC1.fuyoList" :key="row.noFuyo">
								<td class="padding__top--nyukyolist">
									<label>
										<input
											type="button"
											:value="'遠隔地扶養者表示'"
											class="contents__btn--normal table-button"
											:tabindex="row.noFuyo + formC1.nyukyoList.length"
											@click="openConfirmEnkakuchiFuyosya(row.noFuyo)"
											ref="fuyoBtnMobile">
									</label>
									<br/>
									<label>No</label>:
										{{ row.noFuyo }}
									<br/>
									<label>氏名</label>:
										&nbsp;{{ row.nmFuyoName1 }}&nbsp;&nbsp;{{ row.nmFuyoName2 }}
									<br/>
									<label>申込者との関係</label>:
										{{ row.nmMoukankei }}
									<br />
									<label>年齢</label>:
										満{{ co_calcAge(row.dtBirthday) }}歳
									<br/>
									<label>特別控除</label>:
										&nbsp;{{ row.nmKojto }}
								</td>
							</tr>
						</tbody>
						<div ref="fuyoMobileB"></div>
					</table>
				</div>
				<br/>
				<h2 class="contents__h2">世帯の所得金額と家族人数</h2>
				<table class="contents__table--stripe detail" >
					<tbody>
						<tr>
							<th class="contents__input--title padding__bottom-zero">年間所得金額合計(Ａ)</th>
							<td class="contents__syotoku-kazoku">
								{{ co_commaSeparated(formC1.moAllsyotoku) }} 円
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title padding__bottom-zero">特別控除金額(Ｂ)</th>
							<td class="contents__syotoku-kazoku">
								{{ co_commaSeparated(formC1.moAlltokubetu) }} 円
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title padding__bottom-zero">
								世帯の所得金額
								<div class="font-weight-normal">(Ａ)－(Ｂ)</div>
							</th>
							<td class="contents__syotoku-kazoku">
								{{ co_commaSeparated(formC1.moAllsasihiki) }} 円
								<br />
								<caution-message
									:classDiv="'contents__syotoku-tyui'"
									:tyuibunItems="disp.syotokuItems"
								/>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title padding__bottom-zero">家族人数</th>
							<td colspan="3" class="contents__syotoku-kazoku">
								{{ Number(formC1.nuNyukyo) + Number(formC1.fuyoList.length) }}人
								<div class="contents__caution--div line-height kazoku-nunzu">
									<div class="contents__caution--div_mark kazoku-tyui">
										<p class="contents__caution contents__caution--multiple kazokuNizu-tyui">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple kazokuNizu-tyui">
											家族人数とは、都営住宅に入居する人数に遠隔地扶養者を加えた人数です。
										</p>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<br/>
				<div v-if="formC1.bosyuHoshiki != BOSYU_HOSHIKI.TEIKI_POINT">
					<div class="toei-jyutaku">
						<h2 class="contents__h2">別居予定者（現在申込者と同居しているが、都営住宅に入居せず、別居する予定の方）</h2>
					</div>
					<br/>
					<div>
						<div class="width-bekkyoUmu">
							<span v-if="disp.zuiziFlg">
								現在、申込者と同居している方のなかに、都営住宅には入居しない方（別居予定者）がいますか。
							</span>
							<span v-else>
								申込期間に申込者と同居している方のなかに、都営住宅には入居しない方（別居予定者）がいますか。
							</span>
						</div>
						<div v-if="formC1.kbBekkyoyotei == 2" class="width-bekkyoUmu2">
							いいえ
						</div>
						<div v-else class="width-bekkyoUmu2">
							<div>
								はい
							</div>
							<caution-message
								:cdHanyo1="'T0011'"
								:cdHanyo2="formC1.bosyuHoshiki"
							/>
							<div class="width-bekkyoUmu3">
								<span class="font-size">別居する理由・状況</span><br>
							</div>
							<div>
								<p class="contents__textarea--display" v-text="formC1.txBekkyozyokyo"/>
							</div>
						</div>
					</div>
					<br/>
					<h2 class="contents__h2 height-auto">現在のお住まいについて
					</h2>
					<table class="contents__table--stripe detail_split" >
						<tbody>
							<tr>
								<th  class="contents__input--title width-jyutakuKind-title">住宅の種類</th>
								<td colspan="3" class="width-80per padding__top">
									{{ disp.nmNowjyutaku }}
									<caution-message
										:classDiv="'padding__top--nowjyutaku'"
										:tyuibunItems="disp.jyutakuItems"
									/>
								</td>
							</tr>
							<tr>
								<th class="contents__input--title width-yatin-title">家賃</th>
								<td colspan="3" class="font-size padding__top">
									<div v-if="formC1.moNowyachin != null && formC1.moNowyachin != ''" class="margin-bottom-20">
										月額 {{ co_commaSeparated(formC1.moNowyachin) }} 円
									</div>
									<div v-else class="height-notentered">
									</div>
									<div class="contents__caution--div div_row">
										<div class="contents__caution--div_mark">
											<p class="contents__caution contents__caution--multiple">
											※
											</p>
										</div>
										<div>
											<p class="contents__caution contents__caution--multiple">
												共益費、駐車場料金等を除く。
											</p>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<th  class="contents__input--title width-madori-title">間取り</th>
								<td class="width-madori padding__top">
									{{ disp.nmNowmadori }}
								</td>
								<th class="contents__input--title width-tatamisu-title">
									間取りのK・DK・LDKを<br/>
									除いた部分の畳数の合計<br/>
								</th>
								<td class="width-tatamisu padding__top">
									<div v-if="formC1.nuNowtatamisu != null && formC1.nuNowtatamisu != ''">
										合計 {{ formC1.nuNowtatamisu }} 畳
									</div>
									<div v-else class="height-notentered">
									</div>
								</td>
							</tr>
							<tr>
								<th  class="contents__input--title ">住戸専用面積</th>
								<td colspan="3" class="narrow_row padding__top">
									<div class="font-size">
										<div v-if="formC1.nuNowsenyo != null && formC1.nuNowsenyo != ''" class="margin-bottom-20">
											{{ formC1.nuNowsenyo }} m&sup2;
										</div>
										<div v-else class="height-notentered">
										</div>
									</div>
									<div class="senyoArea-tyui">
										<div class="contents__caution--div div_row">
											<div class="contents__caution--div_mark">
												<p class="contents__caution contents__caution--multiple">
												※
												</p>
											</div>
											<div>
												<p class="contents__caution contents__caution--multiple">
													住宅が狭いことを理由とした、都営住宅等公的住宅からの申込み及び世帯を分離する申込みの方のみ
												</p>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
					<br />
					<h2 class="contents__h2">都営住宅に入居する方について</h2>
					<table class="contents__table--stripe detail" >
						<tbody>
							<tr>
								<th class="contents__input--title">階段の上り下りが困難な方がいますか</th>
								<td class="kaidan-title padding__top">
									{{ disp.nmKaidan }}
								</td>
							</tr>
							<tr>
								<th class="contents__input--title">それぞれに該当する方がいれば選択</th>
								<td class="width-tokubetu">
									{{ disp.nmTokubetu }}
									<caution-message
										:classDiv="'contents__syotoku-tyui'"
										:tyuibunItems="disp.tokubetuItems"
									/>
								</td>
							</tr>
							<tr>
								<th class="contents__input--title line-height">心身障害者を含む世帯について該当する方がいれば選択</th>
								<td class="padding__top">
									<div>
										<check-box
											:classDiv="'width-shinshin1'"
											:modelValue="formC1.kbShinGaitokomoku1"
											:name="'心身障害者該当項目１'"
											:groupId="'kbShinGaitokomoku1'"
											:cdType="'L0109'"
											:cdHanyo1="'1'"
											:disabledFlg="true"
											@update:modelValue="formC1.kbShinGaitokomoku1 = $event"
											ref="kbShinGaitokomoku1"
										/>
									</div>
									<div class="margin-top-35">
										<check-box
											:classDiv="'width-shinshin2'"
											:modelValue="formC1.kbShinGaitokomoku2"
											:name="'心身障害者該当項目２'"
											:groupId="'kbShinGaitokomoku2'"
											:cdType="'L0109'"
											:cdHanyo1="'2'"
											:disabledFlg="true"
											@update:modelValue="formC1.kbShinGaitokomoku2 = $event"
											ref="kbShinGaitokomoku2"
										/>
									</div>
									<div class="margin-top-35">
										<check-box
											:classDiv="'width-shinshin3'"
											:modelValue="formC1.kbShinGaitokomoku3"
											:name="'心身障害者該当項目３'"
											:groupId="'kbShinGaitokomoku3'"
											:cdType="'L0109'"
											:cdHanyo1="'3'"
											:disabledFlg="true"
											@update:modelValue="formC1.kbShinGaitokomoku3 = $event"
											ref="kbShinGaitokomoku3"
										/>
									</div>
									<div class="margin-top-35">
										<check-box
											:classDiv="'width-shinshin4'"
											:modelValue="formC1.kbShinGaitokomoku4"
											:name="'心身障害者該当項目４'"
											:groupId="'kbShinGaitokomoku4'"
											:cdType="'L0109'"
											:cdHanyo1="'4'"
											:disabledFlg="true"
											@update:modelValue="formC1.kbShinGaitokomoku4 = $event"
											ref="kbShinGaitokomoku4"
										/>
									</div>
								</td>
							</tr>
							<tr>
								<th class="contents__input--title contents__totiSyoyu">住宅や土地を所有している方がいますか</th>
								<td class="totiSyoyu-title padding__top">
									<div style="display:block;">
										<div>
											{{ disp.nmKSyoyu }}
										</div>
										<div v-if="formC1.bosyuHoshiki != BOSYU_HOSHIKI.ZUIJI" class="contents-nmKSyoyuHosoku">
											{{ disp.nmKSyoyuHosoku }}
										</div>
										<div v-else class="height-totiSyoyuTyui"></div>
										<div v-if="formC1.kbSyoyu == '2'">
											<caution-message
												:classDiv="'contents__totisyoyu-tyui'"
												:tyuibunItems="disp.syoyuItems"
											/>
										</div>
										</div>
								</td>
							</tr>
							<tr>
								<th class="contents__input--title line-height">申込確定にあたっては、以下の事項に誓約・同意することが必要です。</th>
								<td class="padding__top--seiyaku font-size">
									<div class="doui-tyui">
										<seikyu-message
											:tyuibunItems="disp.seiyakuItems"
										/>
									</div>
									<div class="width-seiyakuDoui">
										<check-box
											:classDiv="'font-size'"
											:modelValue="formC1.fgSeiyakuDoui"
											:name="'誓約・同意'"
											:groupId="'fgSeiyakuDoui'"
											:listItems="disp.seiyakuDouiList"
											:disabledFlg="true"
											@update:modelValue="formC1.fgSeiyakuDoui = $event"
											ref="fgSeiyakuDoui" />
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="formC1.bosyuHoshiki == BOSYU_HOSHIKI.ZUIJI">
					<br />
					<h2  class="contents__h2">ご希望の住宅の条件（やむを得ない事情がある場合のみ記入）
												<br />※ご希望に沿った住宅がご用意できない場合もあります。あらかじめご了承ください。</h2>
					<table class="contents__table--stripe detail" >
						<tbody>
							<tr>
								<td>
									<div id="contents--name__area">
										<p class="contents__textarea--display" v-text="formC1.txKiboJyoken"/>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="formC1.bosyuHoshiki == BOSYU_HOSHIKI.TEIKI_POINT">
					<div class="toei-jyutaku">
						<h2 class="contents__h2">別居予定者（現在申込者と同居しているが、都営住宅に入居せず、別居する予定の方）</h2>
					</div>
					<div>
						<br/>
						<div class="width-bekkyoUmu">
							申込期間に申込者と同居している方のなかに、都営住宅には入居しない方（別居予定者）がいますか。
						</div>
						<div v-if="formC1.kbBekkyoyotei == 2" class="width-bekkyoUmu2">
							いいえ
						</div>
						<div v-else class="width-bekkyoUmu2">
							はい
							<caution-message
								:cdHanyo1="'T0011'"
								:cdHanyo2="formC1.bosyuHoshiki"
							/>
						</div>
						<br/>
					</div>
					<div class="contents__div--PC">
						<table  class="list4 border__collapse clear-both">
							<thead>
								<tr id="listheader" class="contents__list font-size">
									<th class="contents__thtd--btn"></th>
									<th class="contents__table--nyukyo">No</th>
									<th class="contents__table--nyukyo">氏名</th>
									<th class="contents__table--nyukyo">続柄</th>
									<th class="contents__table--nyukyo">年齢</th>
									<th class="contents__table--nyukyo">都営住宅に入らない理由</th>
								</tr>
							</thead>
							<tbody>
								<tr id="listcountents" v-for="row in formC1.bekkyoList" :key="row.noBekkyo" class="font-size">
									<td class="contents__thtd--btn">
										<input
											type="button"
											:value="'別居予定者表示'"
											class="contents__btn--normal table-button"
											:tabindex="row.noBekkyo + formC1.nyukyoList.length + formC1.fuyoList.length"
											@click="openConfirmBekkyoyoteisya(row.noBekkyo)"
											ref="bekkyoBtn">
									</td>
									<td class="contents__table--nyukyo">{{ row.noBekkyo }}</td>
									<td class="text-align-left contents__table--nyukyo">
										&nbsp;{{ row.nmBeName1 }}&nbsp;&nbsp;{{ row.nmBeName2 }}
									</td>
									<td class="contents__table--nyukyo">
										{{ row.nmBeTudukigara }}
									</td>
									<td class="contents__table--nyukyo">
										<span v-if="!co_isEmpty(row.dtBeBirthday)">
											満{{ co_calcAge(row.dtBeBirthday) }}歳
										</span>
										<span v-else>&nbsp;</span>
									</td>
									<td class="text-align-left contents__table--nyukyo contents__listarea--display">
										&nbsp;{{ row.txRiyu }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div  class="contents__div--MOBILE">
						<table class="contents__table--stripe detail list width-list">
							<tbody>
								<tr v-for="row in formC1.bekkyoList" :key="row.noBekkyo">
									<td class="padding__top--nyukyolist">
										<label>
											<input
												type="button"
												:value="'別居予定者表示'"
												class="contents__btn--normal table-button"
												:tabindex="row.noBekkyo + formC1.nyukyoList.length + formC1.fuyoList.length"
												@click="openConfirmBekkyoyoteisya(row.noBekkyo)"
												ref="bekkyoBtnMobile">
										</label>
										<br/>
										<label>No</label>:
											{{ row.noBekkyo }}
										<br/>
										<label>氏名</label>:
											&nbsp;{{ row.nmBeName1 }}&nbsp;&nbsp;{{ row.nmBeName2 }}
										<br/>
										<label>続柄</label>:
											{{ row.nmBeTudukigara }}
										<br />
										<label>年齢</label>:
											<span v-if="!co_isEmpty(row.dtBeBirthday)">
												満{{ co_calcAge(row.dtBeBirthday) }}歳
											</span>
											<span v-else>&nbsp;</span>
										<br/>
										<label>都営住宅に入らない理由</label>:
										<span class="contents__listarea--display">
											&nbsp;{{ row.txRiyu }}
										</span>
									</td>
								</tr>
							</tbody>
							<div ref="bekkyoMobileB"></div>
						</table>
					</div>
					<br />
					<h2 class="contents__h2">都営住宅に入居する方について</h2>
					<table  class="contents__table--stripe detail" >
						<tbody>
							<tr>
								<th class="contents__input--title">階段の上り下りが困難な方がいますか</th>
								<td class="kaidan-title padding__top">
									{{ disp.nmKaidan }}
								</td>
							</tr>
							<tr>
								<th class="contents__input--title">それぞれに該当する方がいれば選択</th>
								<td class="width-tokubetu">
									{{ disp.nmTokubetu }}
									<caution-message
										:classDiv="'contents__syotoku-tyui'"
										:tyuibunItems="disp.tokubetuItems"
									/>
								</td>
							</tr>
							<tr>
								<th class="contents__input--title">全員が生活保護等を受給していますか</th>
								<td class="padding__top hogo-title">
									<div>
										{{ disp.nmKyufuJyukyuUmu }}
									</div>
									<div class="width-zyukyu">
										<span class="font-size-20">生活保護等とは </span>
										<br/>
										<span>生活保護または「中国残留邦人等の円滑な帰国の促進並びに永住帰国した中国残留邦人等及び特定配偶者の自立の支援に関する法律」による支援給付をいいます。 </span>
									</div>
								</td>
							</tr>
							<tr>
								<th class="contents__input--title contents__totiSyoyu">住宅や土地を所有している方がいますか</th>
								<td class="totiSyoyu-title padding__top">
									<div style="display:block;">
										<div>
											{{ disp.nmKSyoyu }}
										</div>
										<div class="contents-nmKSyoyuHosoku">
											{{ disp.nmKSyoyuHosoku }}
										</div>
										<div v-if="formC1.kbSyoyu == '2'">
											<caution-message
												:classDiv="'contents__totisyoyu-tyui'"
												:tyuibunItems="disp.syoyuItems"
											/>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
					<div v-if="formC1.kbZyutaku == '21'"> 
						<br />
						<h2 class="contents__h2">車いす使用者について</h2>
						<table class="contents__table--stripe detail" >
							<tbody>
								<tr>
									<th class="contents__input--title">車いす使用者の氏名</th>
									<td class="padding__top">
										<div id="contents--name__area">
											<div>
												氏：{{ formC1.nmKuruname1 }}
											</div>
											<div>
												名：{{ formC1.nmKuruname2 }}
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title">該当する項目にチェック</th>
									<td class="padding__top">
										<div>
											<check-box
												:classDiv="'width-hisaisya'"
												:modelValue="formC1.kbGaitoKomoku1"
												:name="'車いす該当項目１'"
												:groupId="'kbGaitoKomoku1'"
												:cdType="'L0061'"
												:cdHanyo1="'1'"
												:disabledFlg="true"
												@update:modelValue="formC1.kbGaitoKomoku1 = $event"
												ref="kbGaitoKomoku1"
											/>
										</div>
										<div class="margin-top-35">
											<check-box
												:classDiv="'width-hisaisya'"
												:modelValue="formC1.kbGaitoKomoku2"
												:name="'車いす該当項目２'"
												:groupId="'kbGaitoKomoku2'"
												:cdType="'L0061'"
												:cdHanyo1="'2'"
												:disabledFlg="true"
												@update:modelValue="formC1.kbGaitoKomoku2 = $event"
												ref="kbGaitoKomoku2"
											/>
										</div>
										<div class="margin-top-35">
											<check-box
												:classDiv="'width-hisaisya'"
												:modelValue="formC1.kbGaitoKomoku3"
												:name="'車いす該当項目３'"
												:groupId="'kbGaitoKomoku3'"
												:cdType="'L0061'"
												:cdHanyo1="'3'"
												:disabledFlg="true"
												@update:modelValue="formC1.kbGaitoKomoku3 = $event"
												ref="kbGaitoKomoku3"
											/>
										</div>
										<div class="shintaiTetyo1 margin-top-30">
											・身体障害者手帳1級
										</div>
										<div class="shintaiTetyo2 margin-top-30">
											・身体障害者手帳2級
										</div>
										<div class="sensyoTetyo margin-top-30 margin-bottom--5">
											・戦傷病者手帳（恩給法別表第1号表ノ2の第1項症以上の障害者）
										</div>
										<div class="margin-top-35 margin-bottom-15">
											<check-box
												:classDiv="'width-hisaisya'"
												:modelValue="formC1.kbGaitoKomoku4"
												:name="'車いす該当項目４'"
												:groupId="'kbGaitokomoku4'"
												:cdType="'L0061'"
												:cdHanyo1="'4'"
												:disabledFlg="true"
												@update:modelValue="formC1.kbGaitoKomoku4 = $event"
												ref="kbGaitoKomoku4"
											/>
										</div>
										<div class="contents__caution--div line-height div_row font-size">
											<div class="contents__caution--div_mark">
												<p class="contents__caution contents__caution--multiple">
													※
												</p>
											</div>
											<div>
												<p class="contents__caution contents__caution--multiple">
													車いす使用の証明書を提出できることまたは資格審査のときに車いす使用者本人が来社することで車いす使用を証明できることが必要です。 
												</p>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title">申込期間に車いす使用者が居住している住宅に風呂はありますか</th>
									<td class="padding__top">
										{{ disp.nmFuroUmu }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<br />
				<div align="center" class="contents__btn-statement">
					<div v-if="disp.hanyoCode == '3' && formC1.bosyuHoshiki == BOSYU_HOSHIKI.TEIKI_POINT" class="contents__caution--multiple btn-statement1">
						<label class="font-size">入力した内容に間違いがなければ「住宅状況入力へ」ボタンをクリックしてください。</label>
					</div>
					<div v-else class="contents__caution--multiple btn-statement1">
						<label class="font-size">このまま申込む場合、「上記の内容で申込む」ボタンをクリックしてください。</label>
					</div>
					<div class="contents__caution--multiple btn-statement2">
						<label class="font-size">入力した内容を修正する場合、「申込み内容を修正する」ボタンをクリックしてください。</label>
					</div>
				</div>
				<div class="contents__div--center margin__bottom-page">
					<a v-if="disp.hanyoCode == '3' && formC1.bosyuHoshiki == BOSYU_HOSHIKI.TEIKI_POINT" id="modal-open2" class="button-link2 decoration-none">
						<input
							type="button"
							value="住宅状況入力へ"
							class="contents__btn--confirm btn-itiji-hozon"
							tabindex="98"
							ref="zyutakuzyokyoBtn"
							@click="clickZyutakuzyokyoBtn"/>
					</a>
					<a v-else id="modal-open2" class="button-link2 decoration-none">
						<input
							type="button"
							value="上記の内容で申込む"
							class="contents__btn--confirm btn-itiji-hozon"
							tabindex="98"
							ref="mosikomiBtn"
							@click="clickMosikomiBtn"/>
					</a>
					<input
						type="button"
						value="申込み内容を修正する"
						class="contents__btn--cancel btn-modoru"
						tabindex="99"
						@click="clickBackBtn"/>
				</div>
			</section>
		</div>
	</main>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import CautionMessage from '@/components/CautionMessage.vue';
import SeiyakuMessage from '@/components/SeiyakuMessage.vue';
import CheckBox from '@/components/CheckBox.vue';
import StepBar from '@/components/StepBar.vue';

import { co_post, co_put, co_setError } from '@/common/ajaxUtility.js';
import { co_isEmpty } from '@/common/checkUtility';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_confirmDialog, co_completedDialog } from '@/common/dialogUtility.js';
import { co_commaSeparated, co_editDate, co_calcAge } from '@/common/stringUtility.js';
import { co_doLogout } from '@/common/logoutEventUtility.js';
import { co_isIE, co_isMobile, co_isSafari } from '@/common/browserUtility.js'; 
import { co_toTop, co_toTrans, co_toTransCtrl } from '@/common/screenUtility.js';

import { HTTP_STATUS, BOSYU_HOSHIKI } from '@/const/const.js';
import { DIALOG_BUTTON_LIST_KEY, ZENKAKU_HYPHEN, SINGLE_ZYUTAKU_SYUBETU } from '@/const/const.js';
import { STORE_ERROR_CLEAR, STORE_VIEW_PROGRESS, STORE_ERROR_SETMSG, STORE_DATA_ADD_DATA } from '@/const/store.js';
import { PATH_BC009_INIT, PATH_BC009_CHECK, PATH_BC009_ENTRY, API_LIST_ITEMS, PATH_BC009_SET_DATA } from '@/const/route.js';
export default {
	name: "BC009C1",
	components: {
		'error-message': ErrorMessage,
		'caution-message': CautionMessage,
		'seikyu-message': SeiyakuMessage,
		'check-box': CheckBox,
		'step-bar': StepBar,
	},
	props: ['form', 'sourceInfo'],
	data: function () {
		return {
			disp: {
				zyutakuzyohoInfo:[],		// 募集住宅情報
				nyukyoSu: '',				// 入居人数
				kbNyukyoSu: '',				// 入居人数区分
				noMouchiku: '',				// 申込地区番号
				kbYugu: '',					// 優遇抽せんの有無
				jyutakuName: '',			// 住宅名
				kusicyo: '',				// 代表的な所在地
				trans: '',					// 主な交通機関
				nuBosyukosu: '',			// 募集戸数
				madori: '',					// 間取り
				senyoArea: '',				// 専用面積
				ymkensetu: '',				// 建設年度
				elevatorUmu: '',			// エレベーター
				moSiyoryo: '',				// 使用料
				siyouEtc: '',				// 仕様等
				nuBairitu: '',				// 参考倍率
				jikotaisyo: '',				// 対象階
				jikonaiyo: '',				// 事故内容
				nyukyoLink: '', 			// 入居人数外部リンク
				yuguLink: '',				// 優遇抽せんの有無外部リンク
				jyutakuLink: '',			// 住宅名外部リンク
				syozaitiLink: '',			// 代表的な所在地外部リンク
				transLink: '',				// 主な交通機関外部リンク
				buildLink: '',				// 建設年度外部リンク
				elevatorLink: '',			// エレベーター外部リンク
				shiyoryoLink: '',			// 使用料外部リンク
				shiyoLink: '',				// 仕様等外部リンク
				bairituLink: '',			// 参考倍率外部リンク
				taisyokaiLink: '',			// 対象階外部リンク
				jikoLink: '',				// 事故内容外部リンク
				jyutakuKind: '',			// 住宅の種別
				nmZyutaku: '',				// 住宅の種別名称
				bosyuKind: '',				// 募集の種類
				nmBosyu: '',				// 募集の種類名称
				listHideKbn: 0, 			// 一覧非表示区分(1:参考倍率、2：対象階・事故内容、3：すべて)
				nyukyoItems: [],			// 入居人数注意文
				hisaisyaItems: [],			// 被災者世帯フラグ注意文
				hisaiNaiyoItems: [], 		// 被災の内容注意文
				mouItems1: [],				// 申込区分注意文１
				mouItems2: ['C0018'],		// 申込区分注意文２
				mouItems3: ['C0019'],		// 申込区分注意文３
				ageItems1: ['C0022'],		// 年齢注意文１
				ageItems2: [],				// 年齢注意文２
				ageItems3: ['C0223'],		// 年齢注意文３
				zairyuItems: [],			// 在留資格注意文
				syotokuItems: ['C0031'],	// 所得金額注意文
				jyutakuItems: [],			// 現在の住宅の種類注意文
				nmHisainaiyou: '',			// 被災の内容名
				nmZairyusikaku: '',			// 申込者在留資格名
				nmNowjyutaku: '',			// 現在の住宅の種類名
				nmNowmadori: '',			// 現在の住宅の間取り名
				nmKaidan: '',				// 階段困難区分名
				nmKSyoyu: '',				// 住宅土地所有区分名
				syoyuItems: ['C0218'],		// 住宅土地所有注意文
				nmKSyoyuHosoku: '',			// 住宅土地所有補足区分名
				nmGaifuyo: '',				// 入居外扶養親族
				hisaisyaList: [],			// 被災者世帯での申込み
				seiyakuDouiList: [],		// 誓約・同意リスト
				seiyakuItems: ['C0027'],	// 制約・同意注意文
				hanyoCode: '',				// 汎用コード
				nmTokubetu: '',				// 特別区分名
				tokubetuItems: ['C0220'],	// 特別区分注意文
				nmKyufuJyukyuUmu: '',		// 支援給付の受給有無名
				nmFuroUmu: '',				// 車いす世帯風呂有無名
				unyobi: '',					// 運用日
				zuiziFlg: false,			// 随時募集フラグ
				pointFlg: false,			// ポイント募集フラグ
				zenkakuHyphen: '',			// 全角ハイフン
				singleList: [],				// 単身者リスト
				width: 0,					// 画面幅
				moSyotokuItems: ['C0034'],	// 年間所得金額注意文リスト
				kojtoItems: ['C0187'],		// 特別控除注意文リスト
				nmKojto: '',				// 特別控除名
				kojtoList: [],				// 特別控除リスト
				nmTecyo1: '',				// 申込者身体障害者手帳の所有有無名
				nmTokyu1: '',				// 等級等名（身体障害者手帳）
				nmTecyo2: '',				// 申込者愛の手帳の所有有無名
				nmTokyu2: '',				// 等級等名（愛の手帳）
				nmTecyo3: '',				// 申込者精神障害者保健福祉手帳の所有有無名
				nmTokyu3: '',				// 等級等名（精神障害者保健福祉手帳）
				nmTecyo4: '',				// 障害程度の判定有無名
				nmSyogaiTokyu: '',			// 年金証書の障害等級名
				nmSindanSyurui: '',			// 診断書の種類名
				nmSyokugyo: '',				// 申込者職業（名称）
				aloneFlg: false,			// 入居者１人フラグ
				dokyoY: 300,				// 同居者一覧Y軸座標
				enkakukuchiY: 350,			// 遠隔地扶養者一覧Y軸座標
				bekkyoY: 500,				// 別居予定者一覧Y軸座標
				stepFlg: false,				// ステップ表示フラグ
				isAkijyuko: false,			// 空き住戸数表示フラグ（True：表示する、False：表示しない）
				nuAkijyukosu: '',			// 空き住戸数
			},
			formC1: [],						// 入力FORM
			ZENKAKU_HYPHEN: ZENKAKU_HYPHEN,
			SINGLE_ZYUTAKU_SYUBETU: SINGLE_ZYUTAKU_SYUBETU,
			BOSYU_HOSHIKI: BOSYU_HOSHIKI,
			co_commaSeparated: co_commaSeparated,
			co_editDate: co_editDate,
			co_calcAge: co_calcAge,
			co_isIE: co_isIE,
			co_isMobile: co_isMobile,
			co_isSafari: co_isSafari,
			co_isEmpty: co_isEmpty
		}
	},
	mounted: async function () {
		await this.$nextTick();

		if (this.$route.fullPath.indexOf('#BC009C1') == -1) {

			// ページトップへ遷移
			co_toTop();
		} else {
			this.disp.width = window.innerWidth;
			if (this.sourceInfo.transKbn == '2') {
				// 同居者確認画面からの戻り
				// フォーカス設定
				await this.$nextTick();
				if (this.disp.width < 768) {
					this.setMobileFocus();
				} else {
					if (this.sourceInfo.selectNo < 0) {
						this.$refs.nyukyoBtn[0].focus();
					} else {
						this.$refs.nyukyoBtn[this.sourceInfo.selectNo].focus();
					}
				}
			} else if (this.sourceInfo.transKbn == '3') {
				// 遠隔地扶養者確認画面からの戻り
				// フォーカス設定
				await this.$nextTick();
				if (this.disp.width < 768) {
					this.setMobileFocus();
				} else {
					if (this.sourceInfo.selectNo < 0) {
						this.$refs.fuyoBtn[0].focus();
					} else {
						this.$refs.fuyoBtn[this.sourceInfo.selectNo].focus();
					}
				}
			} else if (this.sourceInfo.transKbn == '4') {
				// 別居予定者確認画面からの戻り
				// フォーカス設定
				await this.$nextTick();
				if (this.disp.width < 768) {
					this.setMobileFocus();
				} else {
					if (this.sourceInfo.selectNo < 0) {
						this.$refs.bekkyoBtn[0].focus();
					} else {
						this.$refs.bekkyoBtn[this.sourceInfo.selectNo].focus();
					}
				}
			}
		}
	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 同機能内のパラメータ受け渡し
		this.formC1 = this.form;

		// 制約・同意
		this.disp.seiyakuDouiList = [
			{ idCd: '1', nmCd: '上記について誓約・同意する'}
		];

		// ご利用端末
		this.disp.enquete1List = [
			{ idCd: '1', nmCd: 'ＰＣ'},
			{ idCd: '2', nmCd: 'スマホ・タブレット'}
		];

		// 全角ハイフン設定
		this.disp.zenkakuHyphen = ZENKAKU_HYPHEN;

		let self = this;
		let nameInfo = await co_post(PATH_BC009_INIT, this.formC1, function (res, handle) {
			if (res.status == HTTP_STATUS.OK) {
				return handle(res);
			} else {
				// ローディング表示終了
				self.$store.commit(STORE_VIEW_PROGRESS, false);
			}
		});

		if (nameInfo != null) {
			this.disp.nmHisainaiyou		=	nameInfo.nmHisainaiyou;		// 被災の内容名
			this.disp.nmZairyusikaku	=	nameInfo.nmZairyusikaku;	// 申込者在留資格名
			this.disp.nmNowjyutaku		=	nameInfo.nmNowjyutaku;		// 現在の住宅の種類名
			this.disp.nmNowmadori		=	nameInfo.nmNowmadori;		// 現在の住宅の間取り名
			this.disp.nmKaidan			=	nameInfo.nmKaidan;			// 階段困難区分名
			this.disp.nmKSyoyu			=	nameInfo.nmKSyoyu;			// 住宅土地所有区分名
			this.disp.nmKSyoyuHosoku	=	nameInfo.nmKSyoyuHosoku;	// 住宅土地所有補足区分名
			this.disp.nmTokubetu		=	nameInfo.nmTokubetu;		// 特別区分名
			this.disp.nmKyufuJyukyuUmu	=	nameInfo.nmKyufuJyukyuUmu;	// 支援給付の受給有無名
			this.disp.nmFuroUmu			=	nameInfo.nmFuroUmu;			// 車いす世帯風呂有無名
			this.disp.unyobi			=	nameInfo.unyobi;			// 運用日
			this.formC1.nyukyoList		=	nameInfo.nyukyoList;		// 入居者情報リスト
			this.disp.nmTecyo1			=	nameInfo.nmTecyo1;			// 身体障害者手帳の所有有無名
			this.disp.nmTokyu1			=	nameInfo.nmTokyu1;			// 等級等名（身体障害者手帳）
			this.disp.nmTecyo2			=	nameInfo.nmTecyo2;			// 愛の手帳の所有有無名
			this.disp.nmTokyu2			=	nameInfo.nmTokyu2;			// 等級等名（愛の手帳）
			this.disp.nmTecyo3			=	nameInfo.nmTecyo3;			// 精神障害者保健福祉手帳の所有有無名
			this.disp.nmTokyu3			=	nameInfo.nmTokyu3;			// 等級等名（精神障害者保健福祉手帳）
			this.disp.nmTecyo4			=	nameInfo.nmTecyo4;			// 障害程度の判定有無名
			this.disp.nmSyogaiTokyu		=	nameInfo.nmSyogaiTokyu;		// 年金証書の障害等級名
			this.disp.nmSindanSyurui	=	nameInfo.nmSindanSyurui;	// 診断書の種類名
			this.disp.nmSyokugyo		=	nameInfo.nmSyokugyo;		// 申込者職業（名称）
		}

		// 前画面からの住宅情報を設定
		this.disp.nyukyoSu = this.formC1.zyutakuInfo.nyukyoSu.trim();
		this.disp.noMouchiku = this.formC1.zyutakuInfo.noMouchiku;
		this.disp.kbYugu = this.formC1.zyutakuInfo.kbYugu;
		this.disp.jyutakuName = this.formC1.zyutakuInfo.jyutakuName;
		this.disp.kusicyo = this.formC1.zyutakuInfo.kusicyo;
		this.disp.trans = this.formC1.zyutakuInfo.trans;
		this.disp.nuBosyukosu = this.formC1.zyutakuInfo.nuBosyukosu;
		this.disp.nuAkijyukosu = this.formC1.zyutakuInfo.nuAkijyukosu;
		this.disp.madori = this.formC1.zyutakuInfo.madori;
		this.disp.senyoArea = this.formC1.zyutakuInfo.senyoArea;
		this.disp.ymkensetu = this.formC1.zyutakuInfo.ymkensetu;
		this.disp.elevatorUmu = this.formC1.zyutakuInfo.elevatorUmu;
		this.disp.moSiyoryo = this.formC1.zyutakuInfo.moSiyoryo;
		this.disp.siyouEtc = this.formC1.zyutakuInfo.siyouEtc;
		this.disp.nuBairitu = this.formC1.zyutakuInfo.nuBairitu;
		this.disp.jikotaisyo = this.formC1.zyutakuInfo.jikotaisyo;
		this.disp.jikonaiyo = this.formC1.zyutakuInfo.jikonaiyo;
		this.disp.nmZyutaku = this.formC1.zyutakuInfo.nmZyutaku;
		this.disp.nmBosyu = this.formC1.zyutakuInfo.nmBosyu;
		this.disp.nyukyoLink = this.formC1.zyutakuInfo.nyukyoLink;
		this.disp.yuguLink = this.formC1.zyutakuInfo.yuguLink;
		this.disp.jyutakuLink = this.formC1.zyutakuInfo.jyutakuLink;
		this.disp.syozaitiLink = this.formC1.zyutakuInfo.syozaitiLink;
		this.disp.transLink = this.formC1.zyutakuInfo.transLink;
		this.disp.buildLink = this.formC1.zyutakuInfo.buildLink;
		this.disp.elevatorLink = this.formC1.zyutakuInfo.elevatorLink;
		this.disp.shiyoryoLink = this.formC1.zyutakuInfo.shiyoryoLink;
		this.disp.shiyoLink = this.formC1.zyutakuInfo.shiyoLink;
		this.disp.bairituLink = this.formC1.zyutakuInfo.bairituLink;
		this.disp.taisyokaiLink = this.formC1.zyutakuInfo.taisyokaiLink;
		this.disp.jikoLink = this.formC1.zyutakuInfo.jikoLink;
		this.disp.hanyoCode = this.formC1.zyutakuInfo.hanyoCode;
		// 表示項目制御
		// 随時募集の場合
		if (this.formC1.bosyuHoshiki == BOSYU_HOSHIKI.ZUIJI) {

			this.disp.zuiziFlg = true;
			if (this.formC1.kbZyutaku == '23') {
				this.disp.listHideKbn = 1;
			} else {
				this.disp.listHideKbn = 3;
			}
		// ポイント募集の場合
		} else if (this.formC1.bosyuHoshiki == BOSYU_HOSHIKI.TEIKI_POINT) {

			this.disp.pointFlg = true;
			if (this.formC1.kbZyutaku == '20') {
				this.disp.listHideKbn = 2;
			} else {
				this.disp.listHideKbn = 3;
			}
		// 上記以外の場合
		} else {
			if (this.formC1.zyutakuInfo.zikoUmu == '1') {
				this.disp.listHideKbn = 1;
			} else {
				if ((this.formC1.zyutakuInfo.hanyoCode == '1' && this.formC1.kbZyutaku != '24') || this.formC1.kbZyutaku == '08') {
					this.disp.listHideKbn = 3;
				} else {
					this.disp.listHideKbn = 2;
				}
			}
		}
		// 住宅の種別が世帯向（一般募集住宅）※単身でも入居可能な住宅を含む、または
		// 若年夫婦・子育て世帯向（定期使用住宅・10年期限付）※２人以上の家族向のみ の場合
		if (this.formC1.kbZyutaku == '04' || this.formC1.kbZyutaku == '05') {
			this.disp.isAkijyuko = true;
		}

		// 被災者申込
		if (this.formC1.bosyuHoshiki == BOSYU_HOSHIKI.TEIKI_POINT){
			this.disp.hisaisyaList = [
				{ idCd: '1', nmCd: '大規模災害等被災者世帯として申込む'}
			];
			
		} else{
			this.disp.hisaisyaList = [
				{ idCd: '1', nmCd: '東日本大震災被災者世帯または大規模災害等被災者世帯として申込む'}
			];
		}

		// 同居者リスト非表示データ削除
		let tmpNyukyoList = [];
		for (let i = 0; i < this.formC1.nyukyoList.length; i++) {
			if (!co_isEmpty(this.formC1.nyukyoList[i])) {
				if (this.formC1.nyukyoList[i].isInputCheck){
					tmpNyukyoList.push(this.formC1.nyukyoList[i]);
				}
			}
		}
		this.formC1.nyukyoList = tmpNyukyoList;

		// 遠隔地扶養者リスト非表示データ削除
		let tmpFuyoList = [];
		for (let i = 0; i < this.formC1.fuyoList.length; i++) {
			if (!co_isEmpty(this.formC1.fuyoList[i])) {
				if (this.formC1.fuyoList[i].isInputCheck){
					tmpFuyoList.push(this.formC1.fuyoList[i]);
				}
			}
		}
		this.formC1.fuyoList = tmpFuyoList;

		// 別居予定者情報リスト非表示データ削除
		let tmpBekkyoList = [];
		for (let i = 0; i < this.formC1.bekkyoList.length; i++) {
			if (!co_isEmpty(this.formC1.bekkyoList[i])) {
				if (this.formC1.bekkyoList[i].isInputCheck){
					tmpBekkyoList.push(this.formC1.bekkyoList[i]);
				}
			}
		}
		this.formC1.bekkyoList = tmpBekkyoList;

		// 入居人数注意文
		if (this.formC1.nuDoukyo >= '2' && this.formC1.nuNyukyo == '1') {
			this.disp.nyukyoItems = ['C0021'];
		}

		// 被災者世帯フラグ注意文
		if (this.disp.pointFlg) {
			this.disp.hisaisyaItems = ['C0217'];
		} else {
			this.disp.hisaisyaItems = ['C0082'];
		}

		// 被災の内容注意文
		if (this.formC1.fgHisaisetai == '1') {
			if (this.formC1.kbZyutaku == '20' || this.formC1.kbZyutaku == '21'){
				this.disp.hisaiNaiyoItems = ['C0238'];
			} else {
				this.disp.hisaiNaiyoItems = ['C0016'];
			}
		}

		// 年齢注意文２
		if (!co_isEmpty(this.formC1.dtMoubirthday) && this.formC1.dtMoubirthday.length == 8) {
			if (!co_isEmpty(this.formC1.zyutakuInfo.dtKijun7)) {
				if (this.formC1.zyutakuInfo.dtKijun7 < this.formC1.dtMoubirthday) {
					this.disp.ageItems2 = ['C0023'];
				}
			} else {
				if (co_calcAge(this.formC1.dtMoubirthday) < this.formC1.seinensyaAge) {
					this.disp.ageItems2 = ['C0023'];
				}
			}
		}

		// 在留資格注意文
		this.disp.singleList = SINGLE_ZYUTAKU_SYUBETU;
		if(this.formC1.kbZairyusikaku == '6' && this.disp.singleList.findIndex(item => item == this.formC1.kbZyutaku) == -1){
			this.disp.zairyuItems = ['C0024'];
		}

		// 現在の住宅の種類注意文
		if(this.formC1.zyutakuInfo.cdNyukyo != '11' && this.formC1.zyutakuInfo.cdNyukyo != '31'){
			if(this.formC1.cdNowjyutaku == '7' || this.formC1.cdNowjyutaku == '8' || this.formC1.cdNowjyutaku == '10'
				|| this.formC1.cdNowjyutaku == '11' || this.formC1.cdNowjyutaku == '12') {

				if(!this.disp.zuiziFlg && this.formC1.kbMosikomi != '134') {
					this.disp.jyutakuItems = ['C0025'];
				}
			} else if(this.formC1.cdNowjyutaku == '6' || this.formC1.cdNowjyutaku == '13') {
				this.disp.jyutakuItems = ['C0026'];
			}
		}

		// 特別控除リスト
		this.disp.kojtoList = await this.createNameList('L0024');

		// 特別控除名称変換
		this.disp.nmKojto = this.cdToNamekojto(this.formC1.fgKojto);

		// 同居者一覧制御
		this.disp.aloneFlg = this.formC1.nuNyukyo == '1' ? true : false;

		// ステップ表示制御
		this.disp.stepFlg = true;

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
	},
	watch: {
	},
	methods: {
		// 同居者確認画面遷移
		openConfirmNyukyosya : function (noNyukyo) {
			this.$router.push({hash: '#BC009C2', params:{ noNyukyo: noNyukyo }});
			co_toTransCtrl();
		},
		// 遠隔地扶養者確認画面へ遷移
		openConfirmEnkakuchiFuyosya : function (noFuyo) {
			this.$router.push({hash: '#BC009C3', params:{ noFuyo: noFuyo, form: this.formC1 }});
			co_toTransCtrl();
		},
		// 別居予定者確認画面へ遷移
		openConfirmBekkyoyoteisya : function (noBekkyo) {
			this.$router.push({hash: '#BC009C4', params:{ noBekkyo: noBekkyo, form: this.formC1 }});
			co_toTransCtrl();
		},
		// 上記の内容で申込むボタン押下
		clickMosikomiBtn : async function () {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 確認メッセージ表示
			if (this.formC1.bosyuHoshiki == BOSYU_HOSHIKI.ZUIJI){
				co_confirmDialog(co_getMessage('I0021', this.disp.unyobi), this.checkMosikomi);	
			} else {
				co_confirmDialog(co_getMessage('W0010'), this.checkMosikomi);
			}


		},
		// 住宅状況入力へボタン押下
		clickZyutakuzyokyoBtn : async function () {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 入力値保持
			await co_post(PATH_BC009_SET_DATA, this.formC1);
			this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC009', data: this.formC1 });

			// 住宅状況入力画面に遷移
			let params = {
							transKbn: this.formC1.transKbn,
							kbBosyu: this.formC1.kbBosyu,
							kbZyutaku: this.formC1.kbZyutaku,
							ymBosyu: this.formC1.ymBosyu,
							noMouchiku: this.formC1.noMouchiku,
							noRenzoku: this.formC1.noRenzoku,
							noUketuke: this.formC1.noUketuke
						};
			co_toTrans('BC018', params);
		},
		// 申込み内容を修正するボタン押下
		clickBackBtn : function () {

			// 世帯情報入力画面に遷移
			let params = {
							transKbn: this.formC1.transKbn,
							mosikomiInfo: this.formC1
						};
			co_toTrans('BC008', params);
		},
		// 申込み内容チェック
		checkMosikomi : async function (flg) {

			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				let self = this;
				let checkRet = await co_post(PATH_BC009_CHECK, this.formC1, function (res, handle) {
					if (res.status == HTTP_STATUS.OK) {
						return handle(res);
					} else {
						// ローディング表示終了
						self.$store.commit(STORE_VIEW_PROGRESS, false);
					}
				});

				if (checkRet != null) {
					if (!checkRet.checkMosikomi) {
						// 申込重複エラー
						// 募集年月の日付フォーマット変換
						let ymBosyu = this.formC1.ymBosyu.substring(0, 4) + '年' + this.formC1.ymBosyu.substring(4, 6) + '月';

						// エラーメッセージ：E0020を表示
						this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0020', this.formC1.nmBosyu, ymBosyu));

						// ローディング表示終了
						this.$store.commit(STORE_VIEW_PROGRESS, false);

						// ページトップへ遷移
						co_toTop();

						return;
					}

					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					if (!checkRet.checkRiyosya) {
						// 利用者情報相違
						// 確認メッセージ表示
						co_confirmDialog(co_getMessage('W0003'), this.doUpdateRiyosya);
					} else {
						// 申込み内容登録
						this.formC1.updateRiyosya = false;
						this.doMosikomiEntry();
					}
				}

			}
		},
		// 利用者情報の更新設定
		doUpdateRiyosya : function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 利用者情報の更新設定
				this.formC1.updateRiyosya = true;
			} else {
				this.formC1.updateRiyosya = false;
			}

			// 申込み内容登録
			this.doMosikomiEntry();
		},
		// 申込み内容登録処理
		doMosikomiEntry : async function () {
			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// 申込み内容登録
			await co_put(PATH_BC009_ENTRY, this.formC1, this.callbackEntry);
		},
		// 申込み内容登録処理(コールバック関数)
		callbackEntry: function (res) {
			// 申込み内容登録処理：正常終了
			if (res.status == HTTP_STATUS.CREATED) {
				// プログレスバー非表示
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// 完了メッセージ表示
				co_completedDialog(co_getMessage('I0003'), this.doCompletion);

			} else {
				// 業務エラー表示
				co_setError(res.data, this.$refs);

				// プログレスバー非表示
				this.$store.commit(STORE_VIEW_PROGRESS, false);
			}
		},
		// 申し込み完了
		doCompletion : function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// ログアウト実行
				co_doLogout();

				// ログインに遷移
				co_toTrans('BC001');
			}
		},
		// 名称リスト生成
		createNameList : async function (cd) {
			let resultList = [];
			let params = { cdType: cd, cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
			let list = await co_post( API_LIST_ITEMS, params );
			if ( list != null ) {
				for ( let i = 0; i < list.length; i++ ) {
					// リストを追加
					resultList.push( {idCd: list[i].idCd, nmCd: list[i].nmCd} );
				}
			}
			return resultList;
		},
		// フォーカス設定（モバイル版）
		setMobileFocus: async function () {

			let isMobile = await co_isMobile();
			let isSafari = await co_isSafari();
			switch (this.sourceInfo.transKbn) {
				// 同居者確認画面からの戻り
				case '2':
					if (isMobile && isSafari) {
						const posY = this.$refs.nyukyoMobileB.getBoundingClientRect().top + this.disp.dokyoY;
						window.scrollTo({
							top: posY,
							behavior: 'auto'
						})
					} else {
						if (this.sourceInfo.selectNo < 0) {
							this.$refs.nyukyoBtnMobile[0].focus();
						} else {
							this.$refs.nyukyoBtnMobile[this.sourceInfo.selectNo].focus();
						}
					}
					break;
				// 遠隔地扶養者確認画面からの戻り
				case '3':
					if (isMobile && isSafari) {
						const posY = this.$refs.fuyoMobileB.getBoundingClientRect().top + this.disp.enkakukuchiY;
						window.scrollTo({
							top: posY,
							behavior: 'auto'
						})
					} else {
						if (this.sourceInfo.selectNo < 0) {
							this.$refs.fuyoBtnMobile[0].focus();
						} else {
							this.$refs.fuyoBtnMobile[this.sourceInfo.selectNo].focus();
						}
					}
					break;
				// 別居予定者確認画面からの戻り
				case '4':
					if (isMobile && isSafari) {
						const posY = this.$refs.bekkyoMobileB.getBoundingClientRect().top + this.disp.bekkyoY;
						window.scrollTo({
							top: posY,
							behavior: 'auto'
						})
					} else {
						if (this.sourceInfo.selectNo < 0) {
							this.$refs.bekkyoBtnMobile[0].focus();
						} else {
							this.$refs.bekkyoBtnMobile[this.sourceInfo.selectNo].focus();
						}
					}
					break;
			}
		},
		// コード名称変換（特別控除）
		cdToNamekojto : function (val) {
			let nmKojyo = '';
			if (!co_isEmpty(this.formC1.fgKojto)) {
				// 特別控除を選択している場合
				let kojyoList = val.split(',').sort();
				for (let i = 0; i < kojyoList.length; i++) {
					let index = this.disp.kojtoList.findIndex(item => item.idCd === kojyoList[i]);
					if (index >= 0) {
						nmKojyo = nmKojyo + this.disp.kojtoList[index].nmCd;
						if (i != kojyoList.length - 1) {
							nmKojyo = nmKojyo + '、';
						}
					} 
				}
			}
			return nmKojyo;
		},
	}
}
</script>

<style scoped>
/* 端末がPCの場合 */
@media screen and (min-width: 768px) {

	.contents__div--MOBILE {
		display: none;
	}

	.font-size {
		font-size: 16px !important;
	}

	.contents__main {
		margin-left: 0% !important;
		margin-right: 0% !important;
	}

	.contents__input-main {
		margin-top: -2%;
	}

	.contents__jyutaku {
		margin-top: 1%;
		display: inline-block;
	}

	.contents__mosikomi1,
	.contents__mosikomi2,
	.contents__mosikomi3 {
		margin-top: 1% !important;
		display: inline-block;
	}

	.width-bosyu,
	.width-jyutaku {
		font-size: 16px;
		padding-top: 25px !important;
	}

	.contents__table--stripe td {
		line-height: 0px;
	}

	.contents__nyukyotyui1 {
		font-size: 16px;
		padding-top: 15px !important;
	}

	.contents__nyukyotyui2 {
		font-size: 16px;
	}

	.width-hisaisya {
		font-size: 16px;
		/* line-height: 1.4em; */
		margin-left: -15px;
		margin-bottom: 25px;
	}

	.contents__hisaisyatyui {
		font-size: 16px;
		line-height: 23px;
		margin-top: 25px;
	}

	.hisaiNaiyo-title {
		font-size: 16px;
		font-weight: bold;
	}

	.width-moukbn1 {
		margin-top: 25px;
		margin-bottom: 10px;
		font-size: 16px;
		line-height: 0px;
	}

	.width-moukbn2,
	.width-moukbn3 {
		margin-top: -5px;
		font-size: 16px;
		line-height: 0px;
	}

	.birthday-tyui {
		margin-top: 25px;
	}

	.tel-tyui,
	.kyojyu-tyui {
		font-size: 16px !important;
		margin-top: 25px;
	}

	.zairyu-title {
		border-bottom: none;
	}

	.zairyu-tyui {
		font-size: 16px !important;
		margin-top: -5px;
		margin-bottom: 20px;
	}

	.margin__tusyoTyui {
		margin-left: 5px;
		font-size: 15px;
	}

	.zairyuSikaku-title {
		border-bottom: none;
		line-height: 0px;
	}

	.contents__list {
		font-size: 16px;
		line-height: 25px;
	}

	.table-button {
		margin-bottom: 4%;
		margin-top: 4%;
		font-size: 16px;
	}

	.contents__syotoku-kazoku {
		font-size: 16px;
		padding-top: 25px !important;
	}

	.contents__syotoku-tyui {
		font-size: 16px;
		padding-top: 15px !important;
	}

	.kazoku-nunzu {
		padding-top: 25px !important;
	}

	.kazokuNizu-tyui {
		position: relative;
		top: -5px;
	}

	.width-jyutakuKind-title {
		width: 6.5% !important;
	}

	.width-yatin-title {
		width: 6.5% !important;
	}

	.width-madori-title {
		width: 22%;
	}

	.width-madori {
		width: 28%;
	}

	.width-tatamisu-title {
		width: 30%;
	}

	.width-tatamisu {
		width: 20%;
		font-size: 16px;
	}

	.senyoArea-tyui {
		line-height: 0px;
		font-size: 16px;
	}

	.doui-tyui {
		line-height: 21px;
		margin-bottom: 10px;
		font-size: 16px; 
	}

	.width-seiyakuDoui {
		margin-top: 25px;   
		margin-bottom: 15px;
		margin-left: -10px;
	}

	.contents__btn-statement {
		font-size: 16px;
		text-align: left;
		padding-left: 16%;
		margin-top: 15px;
		margin-bottom: 15px;
	}

	.btn-statement1,
	.btn-statement2 {
		display: inline-block;
		text-align: left;
		width: 82%;
	}

	.btn-itiji-hozon {
		margin-bottom: 2%;
		margin-right: 1%;
	}

	.btn-modoru {
		margin-left: 1%;
	}

	.list {
		margin: 0 auto 30px;
		text-align: center;
	}
	.list tr:nth-child(1){
		background-color: #e7f5ff;
		color: #00008b;
	}
	.detail_split th:nth-child(3) {
		width: 14% !important;
	}
	.detail_split td:nth-child(4) {
		width: 36%;
	}

	.list th:nth-child(1){ width:7%; }
	.list th:nth-child(2){ width:12%; }
	.list th:nth-child(3){ width:24%; }
	.list th:nth-child(4){ width:4%; }
	.list th:nth-child(5){ width:10%; }
	.list th:nth-child(6){ width:10%; }
	.list th:nth-child(7){ width:8%; }
	.list th:nth-child(8){ width:11%; }
	.list th:nth-child(9){ width:4%; }

	.list2 {
		margin: 0 0 30px;
		text-align: center;
	}

	.list2 th:nth-child(1){ width:7%; }
	.list2 th:nth-child(2){ width:1.5%; }
	.list2 th:nth-child(3){ width:7.5%; }
	.list2 th:nth-child(4){ width:6%; }
	.list2 th:nth-child(5){ width:3%; }
	.list2 th:nth-child(6){ width:5.5%; }
	.list2 th:nth-child(7){ width:8%; }
	.list2 th:nth-child(8){ width:9.5%; }

	.list3 {
		margin: 0 0 30px;
		text-align: center;
	}

	.list3 th:nth-child(1){ width:10%; }
	.list3 th:nth-child(2){ width:1%; }
	.list3 th:nth-child(3){ width:13%; }
	.list3 th:nth-child(4){ width:12%; }
	.list3 th:nth-child(5){ width:6%; }
	.list3 th:nth-child(6){ width:11%; }

	.list4 {
		margin: 0 0 30px;
		text-align: center;
	}

	.list4 th:nth-child(1){ width:9%; }
	.list4 th:nth-child(2){ width:1%; }
	.list4 th:nth-child(3){ width:11%; }
	.list4 th:nth-child(4){ width:5%; }
	.list4 th:nth-child(5){ width:7%; }
	.list4 th:nth-child(6){ width:20%; }

	.narrow_row {
		line-height: 1.2em;
	}
	.detail .no_border_bottom .detail_split {
		border-bottom: none;
	}

	.contents__thtd--btn {
		background-color: #fdfdfd;
		border-color: #fdfdfd;
	}

	.contents__caution--multiple {
		line-height: 1.4em !important;
	}

	#listheader {
		background-color: #e7f5ff;
		color: #00008b;
	}

	/* 入居人数(ヘッダ) */
	#listtitle01 {
		width: 7%;
		font-size: 16px;
	}

	/* 申込地区番号(ヘッダ) */
	#listtitle02 {
		width: 10%;
		font-size: 16px;
		padding: 5px 0px;
		line-height: 22px;
	}
	#listtitle12 {
		width: 12%;
		font-size: 16px;
		padding: 5px 0px;
		line-height: 22px;
	}

	/* 住宅名(ヘッダ) */
	#listtitle03 {
		width: 23%;
		font-size: 16px;
		line-height: 22px;
	}
	#listtitle13 {
		width: 24%;
		font-size: 16px;
		line-height: 22px;
	}
	#listtitle23 {
		width: 28%;
		font-size: 16px;
		line-height: 22px;
	}
	#listtitle33 {
		width: 20%;
		line-height: 22px;
	}

	/* 募集戸数(ヘッダ) */
	#listtitle04 {
		width: 4%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 間取り(ヘッダ) */
	#listtitle05 {
		width: 10%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 建設年度(ヘッダ) */
	#listtitle06 {
		width: 10%;
		font-size: 16px;
		line-height: 22px;
	}

	/* 使用料(ヘッダ) */
	#listtitle07 {
		width: 8%;
		font-size: 16px;
	}

	/* 仕様等(ヘッダ) */
	#listtitle08 {
		width: 12%;
		font-size: 16px;
	}
	#listtitle18 {
		width: 11%;
		font-size: 16px;
	}
	#listtitle28 {
		width: 10%;
	}

	/* 参考倍率・事故内容(ヘッダ) */
	#listtitle09 {
		width: 12%;
		font-size: 16px;
	}
	#listtitle19 {
		width: 4%;
		font-size: 16px;
		line-height: 22px;
	}
	/* 空き住戸数(ヘッダ) */
	#listtitle30 {
		width: 6%;
		line-height: 22px;
	}
	#listtd {
		text-align: center;
		font-size: 16px;
		line-height: 21px;
	}
	#listjyusho {
		text-align: left;
		line-height: 21px;
	}
	#listtdleft {
		font-size: 16px;
		line-height: 21px;
	}
	.list-Countents {
		background-color: white !important;
		color: #000000 !important;
	}

	/* 住宅の種別 */
	.padding-jyutaku {
		padding-top: 19px !important;
	}

	.contents__table--nyukyo {
		border: 1px solid #808080;
	}

	.padding__top {
		padding-top: 25px !important;
	}

	.padding__top--nowjyutaku {
		padding-top: 7px !important;
	}

	.padding__top--seiyaku {
		padding-top: 5px !important;
	}

	.height-notentered {
		height: 20px;
	}

	.contents-nmKSyoyuHosoku {
		margin-top: 30px !important;
		margin-bottom: 25px !important;
	}

	.height-totiSyoyuTyui {
		margin-bottom: 25px !important;
	}
	.contents-txMouadr {
		margin-top: 25px !important;
	}
	.contents-txMouadr-last {
		margin-top: 25px !important;
		margin-bottom: 15px !important;
	}

	.padding-zairyu {
		padding-top: 18px!important;
	}

	.width-bekkyoUmu { 
		margin-left: 15px;
	}

	.width-bekkyoUmu2 {
		margin-top: 15px; 
		margin-left: 35px;
	}

	.width-zyukyu {
		margin-top: 26px; 
		line-height: 27px;
	}

	.margin-top-30 {
		margin-top: 30px;
	}

	.margin-top-35 {
		margin-top: 35px;
	}

	.shintaiTetyo1,
	.shintaiTetyo2,
	.sensyoTetyo {
		margin-left:10px;
	}

	.contents__tusyoTyui {
		margin-top: -10px;
		margin-bottom: 30px;
		color: red;
	}

	.margin-top-15 {
		margin-top: 15px;
	}

	.width-tokubetu {
		line-height: 27px !important;
	}

	.margin-bottom-20 {
		margin-bottom: 20px;
	}

	.height-moSyotoku {
		height: 25px;
	}

	.height-kojto {
		height: 25px;
		margin-top: 10px !important;
	}

	.padding__kojto {
		margin-top: 20px !important;
	}

	.width-shinshin1 {
		font-size: 16px;
		margin-left: -15px;
		margin-bottom: -10px;
	}

	.width-shinshin2 {
		font-size: 16px;
		margin-left: -15px;
		margin-bottom: -25px;
		line-height: 24px;
	}

	.width-shinshin3 {
		font-size: 16px;
		margin-left: -15px;
		margin-bottom: -27px;
		line-height: 25px;
	}

	.width-shinshin4 {
		font-size: 16px;
		margin-left: -15px;
		margin-bottom: 0px;
		line-height: 25px;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {

	.padding__top,
	.padding__top--seiyaku,
	.padding__kinmusaki {
		padding-top: 0px !important;
	}

	.padding__bottom-zero {
		padding-bottom: 0px !important;
	}

	.line-height {
		line-height: 21px !important;
	}

	.font-size {
		font-size: 18px !important;
	}

	.contents__div--PC {
		display: none;
	}

	.contents__main {
		margin-left: 3px !important;
		margin-right: 3px !important;
	}

	.contents__list-mobile1 {
		line-height: 30px;
		margin-bottom: 15px;
	}

	.contents__mosikomi1 {
		margin-top: 20px !important;
	}

	.width-bosyu {
		border-bottom: none !important;
		padding-top: 0px !important;
		padding-bottom: 0px !important;
	}

	.jyutaku-title {
		padding-top: 0px !important;
		padding-bottom: 0px !important;
	}

	.width-jyutaku {
		padding-top: 0px !important;
	}

	.contents__nyukyotyui1 {
		font-size: 18px;
		margin-bottom: 3px;
	}

	.contents__nyukyotyui2 {
		font-size: 18px;
		line-height: 20px;
	}

	.hisaiNaiyo-title {
		font-size: 18px;
		font-weight: bold;
		display: flex;
	}

	.width-hisaisya {
		font-size: 18px;
		line-height: 24px;
		margin-right: -13px !important;
	}

	.contents__hisaisyatyui {
		font-size: 18px;
		line-height: 21px;
		margin-top: 12px;
	}

	.width-moukbn1 {
		margin-top: 15px;
		font-size: 18px;
		line-height: 21px;
	}

	.width-moukbn2,
	.width-moukbn3 {
		font-size: 18px;
	}

	.contents__mosikomi2 {
		margin-top: 15px !important;
		font-size: 18px !important;
	}

	.mouKana-title {
		padding-top: 0px !important;
		padding-bottom: 0px !important;
	}

	.contents__tusyoKana {
		padding-top: 0px !important;
		padding-bottom: 0px !important;
	}

	.tel-tyui,
	.kyojyu-tyui {
		font-size: 18px !important;
		line-height: 21px;
	}

	.zairyu-title {
		border-bottom: none;
		padding-bottom: 0px !important;
	}

	.zairyu-tyui {
		font-size: 18px !important;
		margin-bottom: 20px;
	}

	.margin__tusyoTyui {
		margin-left: 5px;
		font-size: 16px;
	}

	.zairyuSikaku-title {
		border-bottom: none !important;
		line-height: 0px;
		padding-top: 15px !important;
	}

	.toei-jyutaku {
		line-height: 22px;
	}

	.width-list {
		width: -webkit-fill-available;
	}

	.contents__huyoName {
		margin-top: 20px !important;
		margin-bottom: 15px !important;
		font-size: 18px;
	}

	.contents__syotoku-kazoku {
		font-size: 18px;
		padding-top: 0px !important;
		margin-top: -5px !important;
	}

	.contents__syotoku-tyui {
		line-height: 21px;
		font-size: 18px;
	}

	.kazoku-tyui {
		line-height: 21px;
		font-size: 18px;
	}

	.width-jyutakuKind-title {
		width: 120px !important;
		padding-bottom: 0px !important;
	}

	.width-yatin-title {
		width: 120px !important;
		padding-bottom: 0px !important;
	}

	.width-madori-title {
		width: 120px !important;
		padding-bottom: 0px !important;
	}

	.width-madori {
		width: 28%;
		padding-top: 0px;
		border-bottom: none !important;
	}

	.senyoArea-tyui {
		line-height: 0px;
		font-size: 18px;
	}

	.kaidan-title,
	.hogo-title,
	.totiSyoyu-title {
		margin-top: -10px;
	}

	.contents__btn-statement {
		font-size: 18px;
		text-align: left;
		padding-left: 15px;
		margin-top: 15px;
	}

	.btn-statement1,
	.btn-statement2 {
		display: inline-block;
		text-align: left;
		margin-bottom: 20px;
	}

	.btn-statement2 {
		display: inline-block;
		text-align: left;
	}

	#contents__page {
		position: relative;
		align-items: center;
		margin-left: auto;
		margin-right: auto;
	}
	#modal-content2 {
		margin-top: -33px;
	}
	.contents__btn--confirm {
		margin-top: 20px;
		margin-bottom: 20px;
		position: relative;
	}
	.list td {
		line-height: 25px;
	}
	.list label {
		font-weight: bold;
	}
	.detail tr:nth-child(even){
		background-color: #f1f2f5;
	}
	.narrow_row {
		line-height: 1.2em;
	}

	.detail th:nth-child(1) {
		width: auto;
	}
	.detail td:nth-child(2) {
		width: auto;
	}

	.contents__caution--multiple {
		line-height: 1.4em;
	}

	/* 住宅の種別 */
	.padding-jyutaku {
		line-height: 1em;
	}

	.width-seiyakuDoui {
		margin-left: -10px;
	}

	.height-notentered {
		height: 20px;
	}

	.birthday-tyui {
		margin-top: 0px;
	}

	.padding__top--nowjyutaku {
		padding-top: 0px;
	}

	.padding__top--nyukyolist {
		padding-top: 10px !important;
	}

	.contents__totisyoyu-tyui {
		line-height: 21px;
	}

	.contents-nmKSyoyuHosoku {
		margin-top: 15px !important;
		line-height: 1.4em;
	}

	.contents-txMouadr {
		margin-top: 0px !important;
	}
	.contents-txMouadr-last {
		margin-top: 0px !important;
		margin-bottom: 0px !important;
	}

	.contents-hisaiNaiyo {
		margin-top: 13px;
	}

	.padding-zairyu {
		padding-top: 10px!important;
	}

	.width-bekkyoUmu { 
		margin-left: 15px;
	}

	.width-bekkyoUmu2 {
		margin-top: 15px; 
		margin-left: 35px;
	}

	.width-zyukyu {
		margin-top: 15px; 
		line-height: 27px;
	}

	.margin-top-30 {
		margin-top: 5px;
	}

	.margin-top-35 {
		margin-top: 15px;
	}

	.shintaiTetyo1,
	.shintaiTetyo2,
	.sensyoTetyo {
		margin-left:10px;
	}

	.contents__tusyoTyui {
		margin-top: 5px;
		margin-bottom: 5px;
		color: red;
	}

	.width-tokubetu {
		margin-top: -15px;
		line-height: 27px !important;
	}

	.margin-bottom-15 {
		margin-bottom: 15px;
	}

	.margin-bottom--5 {
		margin-bottom: -5px;
	}

	.padding__kojto {
		margin-top: 0px !important;
	}

	.height-kojto {
		margin-bottom: 15px;
	}

	.width-shinshin1,
	.width-shinshin2,
	.width-shinshin3,
	.width-shinshin4 {
		font-size: 18px;
		line-height: 24px;
		margin-right: -13px !important;
	}
}

/* IE対応 */
@media all and (-ms-high-contrast: none) {
	.contents__main--mosikomi {
		margin-top: 50px !important;
	}
}

.contents__zairyuTyui {
	margin-top: -5px;
	margin-bottom: 25px;
	color: red;
}

.width-bekkyoUmu3 {
	line-height:20px;
	margin-top:20px;
	margin-left:-20px;
}

.moSyotoku-tyui {
	margin-top: -5px !important;
}

.contents__toggle-nyukyo {
	margin-top: 15px !important;
	margin-bottom: 15px !important;
}
.div-toggle-select-margin {
    margin-top: 10px;
    margin-bottom: 20px;
}

.margin_dokyoList {
	margin-top: 20px;
}
</style>